import { Badge, Group, Text } from "@mantine/core";
import { CommunicationBypassPrefix } from "../../../services/admin/communicationSettings.service";

interface BypassPrefixChangeListProps {
  label: string;
  prefixes: CommunicationBypassPrefix[];
  color: string;
  emptyLabel: string;
}

export default function BypassPrefixChangeList({
  label,
  prefixes,
  color,
  emptyLabel,
}: BypassPrefixChangeListProps) {
  return (
    <Group align="flex-start" wrap="nowrap">
      <Text size="sm" fw={600} w={90}>
        {label}
      </Text>
      <Group gap="xs" wrap="wrap">
        {prefixes.length === 0 ? (
          <Text size="sm" c="dimmed">
            {emptyLabel}
          </Text>
        ) : (
          prefixes.map((prefix) => (
            <Badge key={prefix.id} color={color} variant="light">
              {prefix.code}
            </Badge>
          ))
        )}
      </Group>
    </Group>
  );
}
